import React from 'react';

const UserAvatars = ({ users, maxVisible = 3, size = 'sm' }) => {
  if (!users || users.length === 0) {
    return null;
  }

  // Цвета для разных типов пользователей
  const getColorByType = (type) => {
    switch (type) {
      case 'author':
      case 'owner':
        return 'bg-red-500'; // Красный для автора/владельца
      case 'access':
        return 'bg-blue-500'; // Синий для пользователей с доступом
      default:
        return 'bg-gray-500'; // Серый по умолчанию
    }
  };

  // Размеры аватаров
  const getSizeClasses = (size) => {
    switch (size) {
      case 'xs':
        return 'w-6 h-6 text-xs';
      case 'sm':
        return 'w-8 h-8 text-sm';
      case 'md':
        return 'w-10 h-10 text-base';
      case 'lg':
        return 'w-12 h-12 text-lg';
      default:
        return 'w-8 h-8 text-sm';
    }
  };

  const sizeClasses = getSizeClasses(size);
  const visibleUsers = users.slice(0, maxVisible);
  const hiddenCount = users.length - maxVisible;

  return (
    <div className="flex items-center space-x-1">
      {visibleUsers.map((user, index) => (
        <div
          key={user.id}
          className={`relative group ${index > 0 ? '-ml-2' : ''}`}
        >
          <div
            className={`${sizeClasses} ${getColorByType(user.type)} rounded-full flex items-center justify-center text-white font-medium border-2 border-white shadow-sm cursor-pointer hover:scale-110 transition-transform duration-200`}
            title={`${user.name} (${user.type === 'author' ? 'Исполнитель' : user.type === 'owner' ? 'Владелец' : 'Просмотр'})`}
          >
            {user.name.charAt(0).toUpperCase()}
          </div>
          
          {/* Тултип */}
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
            <div className="font-medium">{user.name}</div>
            <div className="text-gray-300">
              {user.type === 'author' ? 'Исполнитель' : user.type === 'access' ? 'Исполнитель' : 'Просмотр'}
            </div>
            <div className="text-gray-400 text-xs">{user.email}</div>
            {/* Стрелка */}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      ))}
      
      {/* Показать количество скрытых пользователей */}
      {hiddenCount > 0 && (
        <div className="relative group -ml-2">
          <div
            className={`${sizeClasses} bg-gray-400 rounded-full flex items-center justify-center text-white font-medium border-2 border-white shadow-sm cursor-pointer hover:scale-110 transition-transform duration-200`}
            title={`Еще ${hiddenCount} пользователей`}
          >
            +{hiddenCount}
          </div>
          
          {/* Тултип для скрытых пользователей */}
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
            <div className="font-medium">Еще {hiddenCount} пользователей:</div>
            {users.slice(maxVisible).map(user => (
              <div key={user.id} className="text-gray-300">
                {user.name} ({user.type === 'author' ? 'Исполнитель' : user.type === 'access' ? 'Исполнитель' : 'Просмотр'})
              </div>
            ))}
            {/* Стрелка */}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAvatars; 